// src/features/regions/RegionsPageSkeleton.tsx
import React from 'react';
import { SkBox, SkText } from '../../components/SkeletonLoader/SkeletonLoader';
import styles from './RegionsPageSkeleton.module.css';

const KpiCardSk: React.FC = () => (
  <div className={styles.kpiCard}>
    <SkText width="60%" height={12} />
    <SkText width="50%" height={26} />
    <SkText width="35%" height={11} />
  </div>
);

const ClientRowSk: React.FC = () => (
  <div className={styles.clientRow}>
    <SkText width="55%" height={13} />
    <SkText width="25%" height={13} />
  </div>
);

const ChartWidgetSk: React.FC<{ height?: number }> = ({ height = 220 }) => (
  <div className={styles.chartWidget}>
    <SkText width="55%" height={16} />
    <SkBox width="100%" height={height} className={styles.chartArea} />
  </div>
);

const RegionsPageSkeleton: React.FC = () => (
  <div className={styles.skeletonWrapper}>
    {/* KPI row — 5 cards */}
    <div className={styles.kpiRow}>
      {Array.from({ length: 4 }).map((_, i) => <KpiCardSk key={i} />)}
    </div>

    {/* Charts grid — 4 widgets */}
    <div className={styles.chartsGrid}>
      {/* Vendas por Estado — bar chart */}
      <ChartWidgetSk height={250} />

      {/* Clientes na Região — list */}
      <div className={styles.chartWidget}>
        <SkText width="50%" height={16} />
        <div style={{ marginTop: 14 }}>
          {Array.from({ length: 7 }).map((_, i) => <ClientRowSk key={i} />)}
        </div>
      </div>

      {/* Evolução de Vendas — line chart, wide */}
      <ChartWidgetSk height={220} />

      {/* Vendas por Linha — list */}
      <div className={styles.chartWidget}>
        <SkText width="50%" height={16} />
        <div style={{ marginTop: 14 }}>
          {Array.from({ length: 6 }).map((_, i) => <ClientRowSk key={i} />)}
        </div>
      </div>
    </div>
  </div>
);

export default RegionsPageSkeleton;
